import { SectionSummaryContent } from '@/shared/components/SectionSummary.tsx';
import { useTranslation } from 'react-i18next';
import { useFormatters } from '@/shared/hooks/useFormatters/useFormatters.ts';
import { useOrderContext } from '@/modules/order/context/OrderContext.tsx';
import { SUPPORTED_UNIT_LABEL } from '@/phrase/SupportedUnitLabels.ts';
import { AutomaticProductsFormSummary } from '@/shared/forms/AutomaticProductsForm/components/AutomaticProductsFormSummary.tsx';

const ManualOrderProductSelectionSummaryContent = () => {
    const { t } = useTranslation();
    const { formatNumber } = useFormatters();
    const { contextData } = useOrderContext();

    const productConfigurations = contextData.getProductConfigurations();
    const sectionSummaryContentList = (productConfigurations ?? []).map((product, index) => ({
        summaryContentItemId: index,
        label: product.productName,
        value: `${formatNumber(product.quantity)} ${t(SUPPORTED_UNIT_LABEL[product.unit])}`,
    }));

    return <SectionSummaryContent sectionSummaryContentList={sectionSummaryContentList} />;
};

const AutomaticOrderProductSelectionSummaryContent = () => {
    const { contextData } = useOrderContext();

    const formData = contextData.getFormData();
    const businessCase = contextData.getBusinessCase();
    const productConfigurations = contextData.getProductConfigurations();

    if (!businessCase || !formData.productName || !productConfigurations) {
        return;
    }

    return (
        <AutomaticProductsFormSummary
            productName={formData.productName}
            businessCase={businessCase}
            productConfigurations={productConfigurations}
        />
    );
};

export function OrderProductSelectionSummary() {
    const { processingType } = useOrderContext();

    return processingType === 'AUTOMATIC' ? (
        <AutomaticOrderProductSelectionSummaryContent />
    ) : (
        <ManualOrderProductSelectionSummaryContent />
    );
}
